import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-toggle-switch',
  templateUrl: './toggle-switch.component.html',
  styleUrls: ['./toggle-switch.component.less'],
})
export class ToggleSwitchComponent {
  @Input() isChecked: boolean = false;
  @Output() toggleChange = new EventEmitter<boolean>();

  toggleSwitch(event: Event): void {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.toggleChange.emit(isChecked);
  }
}
